import React from 'react';
import { Check } from 'lucide-react';
import { statusWord, statusTone } from './status';

// A PILL: a short state on a thing's corner or beside its name (Connected,
// Installed, Paused, Contract expired, Refused). Its word comes from the one
// vocabulary (status.js) unless given as children; its tone is the state's
// unless given. A thing that is well wears a check. `label` names it for a
// screen reader when its word alone says less than its title.
export default function StatusPill({ status, of, tone, check, title, label, children }) {
    const word = children ?? statusWord(status, of);
    if (word == null || word === '') return null;
    const t = tone || statusTone(status);
    const ticked = check ?? t === 'well';
    return (
        <span className={`nx-pill${t !== 'well' ? ` is-${t}` : ''}`} title={title} aria-label={label}>
            {ticked && <Check aria-hidden="true" />}{word}
        </span>
    );
}
